import React from 'react';
import { withAuth } from '../context/AuthContext';
import DressUpGame from '../component/DressUpGame';
import BackButton from '../component/BackButton';
import BackgroundMusic from '../component/BackgroundMusic';
import music from '../asset/sound/game2.mp3';

function Attire() {
  return (
    <div className="page attire">
      <BackButton />
      <DressUpGame />
      <BackgroundMusic music={music} volume={1} />
    </div>
  );
}

export default withAuth(Attire);
